import { call, put, takeEvery } from 'redux-saga/effects'
import { API } from '../../services'

import {
  // Feedback Type
  getFeedbackTypeListApiData,
  getFeedbackTypeListApiSuccess,
  getFeedbackTypeListApiFailed,
  getFeedbackTypeDetailsApiData,
  getFeedbackTypeDetailsApiSuccess,
  getFeedbackTypeDetailsApiFailed,
  addFeedbackTypeApiData,
  addFeedbackTypeApiSuccess,
  addFeedbackTypeApiFailed,
  updateFeedbackTypeApiData,
  updateFeedbackTypeApiSuccess,
  updateFeedbackTypeApiFailed,
  deleteFeedbackTypeApiData,
  deleteFeedbackTypeApiSuccess,
  deleteFeedbackTypeApiFailed,
  toggleFeedbackTypeStatusApiData,
  toggleFeedbackTypeStatusApiSuccess,
  toggleFeedbackTypeStatusApiFailed,

  // User Feedback
  getUserFeedbackListApiData,
  getUserFeedbackListApiSuccess,
  getUserFeedbackListApiFailed,
  getUserFeedbackDetailsApiData,
  getUserFeedbackDetailsApiSuccess,
  getUserFeedbackDetailsApiFailed,
  updateUserFeedbackStatusApiData,
  updateUserFeedbackStatusApiSuccess,
  updateUserFeedbackStatusApiFailed,
} from './slice'

// ================= Feedback Type =================
function* getFeedbackTypeListApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.getFeedbackTypeList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getFeedbackTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getFeedbackTypeListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getFeedbackTypeListApiFailed({ message: error?.message }))
  }
}

function* getFeedbackTypeDetailsApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.getFeedbackTypeDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getFeedbackTypeDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getFeedbackTypeDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getFeedbackTypeDetailsApiFailed({ message: error?.message }))
  }
}

function* addFeedbackTypeApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.addFeedbackType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addFeedbackTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(addFeedbackTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addFeedbackTypeApiFailed({ message: error?.message }))
  }
}

function* updateFeedbackTypeApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.updateFeedbackType, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateFeedbackTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateFeedbackTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateFeedbackTypeApiFailed({ message: error?.message }))
  }
}

function* deleteFeedbackTypeApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.deleteFeedbackType, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteFeedbackTypeApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteFeedbackTypeApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteFeedbackTypeApiFailed({ message: error?.message }))
  }
}

function* toggleFeedbackTypeStatusApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.toggleFeedbackTypeStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleFeedbackTypeStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleFeedbackTypeStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleFeedbackTypeStatusApiFailed({ message: error?.message }))
  }
}

// ================= User Feedback =================
function* getUserFeedbackListApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.getUserFeedbackList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getUserFeedbackListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getUserFeedbackListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getUserFeedbackListApiFailed({ message: error?.message }))
  }
}

function* getUserFeedbackDetailsApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.getUserFeedbackDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getUserFeedbackDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getUserFeedbackDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getUserFeedbackDetailsApiFailed({ message: error?.message }))
  }
}

function* updateUserFeedbackStatusApi({ payload }) {
  try {
    const response = yield call(API.feedbackManagement.updateUserFeedbackStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateUserFeedbackStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateUserFeedbackStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateUserFeedbackStatusApiFailed({ message: error?.message }))
  }
}

/* ============================
      Root Saga
=============================== */
function* feedbackManagementSaga() {
  // Feedback Type
  yield takeEvery(getFeedbackTypeListApiData, getFeedbackTypeListApi)
  yield takeEvery(getFeedbackTypeDetailsApiData, getFeedbackTypeDetailsApi)
  yield takeEvery(addFeedbackTypeApiData, addFeedbackTypeApi)
  yield takeEvery(updateFeedbackTypeApiData, updateFeedbackTypeApi)
  yield takeEvery(deleteFeedbackTypeApiData, deleteFeedbackTypeApi)
  yield takeEvery(toggleFeedbackTypeStatusApiData, toggleFeedbackTypeStatusApi)

  // User Feedback
  yield takeEvery(getUserFeedbackListApiData, getUserFeedbackListApi)
  yield takeEvery(getUserFeedbackDetailsApiData, getUserFeedbackDetailsApi)
  yield takeEvery(updateUserFeedbackStatusApiData, updateUserFeedbackStatusApi)
}

export default feedbackManagementSaga
